// @module Tavanoteam.Calculator.Calculator
define('Calculator.SquareFoot.Ellipse.View'
    , [
        'calculator_square_foot_ellipse.tpl'

        , 'Backbone'
        , 'jQuery'
    ]
    , function (
        calculator_square_foot_ellipse_tpl

        , Backbone
        , jQuery
    ) {
        'use strict';

        return Backbone.View.extend({

            template: calculator_square_foot_ellipse_tpl

            , initialize: function (options) {
            }

            , events: {
                'click [data-action="calculate-square-foot-ellipse"]': 'calculateArea',
                'click [data-action="reset"]': 'resetAllFields'
            }

            , calculateArea: function calculateArea() {
                //input fields
                var axisA = $('#square-foot-ellipse-axis-a').val(),
                    axisB = $('#square-foot-ellipse-axis-b').val();
                //output fields
                var area = $('#square-foot-ellipse-area');

                var result = Math.PI * parseFloat(axisA) * parseFloat(axisB);

                area.val(result.toFixed(2));
            }

            , resetAllFields: function resetAllFields() {
                $('.calculator-square-foot-ellipse-input-fields').find('input:text').val('');
                $('.calculator-square-foot-ellipse-output-fields').find('input:text').val('');
            }

            , getContext: function getContext()
            {
                return {
                    isActive : true
                }
            }
        });
    });
